// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-weight-loss-program .page-title {
  margin: 0 0 24px;
}

.page-weight-loss-program .content-wrapper {
  padding: 28px 12px;
  background-color: white;
  border-radius: 12px;
}

.page-weight-loss-program .content-wrapper .page-subtitle {
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
}

.page-weight-loss-program .info-block {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--dark-gray);

  margin: 4px auto;
}

.page-weight-loss-program .continue-btn {
  display: block;
  max-width: 264px;
  margin: 40px auto 80px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/weight-loss-program.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;;EAEvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".page-weight-loss-program .page-title {\n  margin: 0 0 24px;\n}\n\n.page-weight-loss-program .content-wrapper {\n  padding: 28px 12px;\n  background-color: white;\n  border-radius: 12px;\n}\n\n.page-weight-loss-program .content-wrapper .page-subtitle {\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.page-weight-loss-program .info-block {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--dark-gray);\n\n  margin: 4px auto;\n}\n\n.page-weight-loss-program .continue-btn {\n  display: block;\n  max-width: 264px;\n  margin: 40px auto 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
